import { Injectable, inject } from '@angular/core';
import { OrderEntryConfiguration } from '../../../../domain/trading.domain';
import { ORDER_ENTRY_USER_CONFIGURATION } from '../domain/order-entry.domain';

@Injectable()
export class TradingSettingsService {
  private readonly orderEntryConfiguration = inject<OrderEntryConfiguration>(ORDER_ENTRY_USER_CONFIGURATION);

  isMloOrdersEnabled(): boolean {
    return this.orderEntryConfiguration.mloOrdersEnabled;
  }

  isComplexOrderEnabled(): boolean {
    return this.orderEntryConfiguration.complexOrdersEnabled;
  }

  isOtaOrdersOptionsEnabled(): boolean {
    return this.orderEntryConfiguration.otaOrdersOptionsEnabled;
  }

  isComplexOrdersOptionsEnabled(): boolean {
    return this.orderEntryConfiguration.complexOrdersOptionsEnabled;
  }

  isAccountAndOrderBuyingPowerEnabled(): boolean {
    return this.orderEntryConfiguration.accountAndOrderBuyingPowerEnabled;
  }
}

